import { isString } from 'lodash'

import { isStringEmpty } from '@/utils/general'

export const GENERIC_EMAIL_DOMAINS = new Set([
  'aol.com',
  'fastmail.com',
  'gmail.com',
  'gmx.com',
  'gmx.net',
  'googlemail.com',
  'hey.com',
  'hotmail.com',
  'icloud.com',
  'inbox.com',
  'live.com',
  'mac.com',
  'mail.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'proton.me',
  'protonmail.com',
  'tutanota.com',
  'yahoo.co.uk',
  'yahoo.com',
  'yandex.com',
  'yandex.ru',
  'zoho.com'
])

export const isGenericEmailDomain = domain => {
  if (!domain) {
    return true
  }

  return GENERIC_EMAIL_DOMAINS.has(domain.toLowerCase())
}

export const extractEmailDomain = email => {
  if (!isString(email)) {
    return null
  }

  const parts = email.trim().split('@')

  if (parts.length < 2) {
    return null
  }

  const domain = parts.at(-1)

  if (!domain) {
    return null
  }

  return domain.toLowerCase()
}

export const getCompanyWebsiteFromEmail = email => {
  const domain = extractEmailDomain(email)

  if (!domain || isGenericEmailDomain(domain)) {
    return null
  }

  return `https://${domain}`
}

export const resolveCompanyWebsiteFromEmail = (companyWebsite, email) => {
  if (!isStringEmpty(companyWebsite)) {
    return companyWebsite
  }

  return getCompanyWebsiteFromEmail(email) ?? ''
}
